import styled, { withTheme } from 'styled-components'
import NakedDefaultItemArticle, {
  Description0NakedDefaultItemArticle,
  Image0NakedDefaultItemArticle,
  Title0NakedDefaultItemArticle,
  TitleLink0NakedDefaultItemArticle,
  TopLine0NakedDefaultItemArticle,
} from '../NakedDefaultItemArticle'
import React from 'react'

const Wrapper = styled(NakedDefaultItemArticle)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (min-width: ${(props) => props.theme.breakPoint + 'px'}) {
    ${Image0NakedDefaultItemArticle} {
      flex-basis: 300px;
    }
    ${Description0NakedDefaultItemArticle} {
      flex: 1;
      padding-left: ${(props) => props.theme.sizes.gapCol};
    }
  }
  @media (max-width: ${(props) => props.theme.breakPoint + 'px'}) {
    ${Image0NakedDefaultItemArticle} {
      flex-basis: ${(props) => props.theme.sizes.col6};
    }

    ${Description0NakedDefaultItemArticle} {
      flex: 1;
      padding-left: ${(props) => props.theme.sizes.gapCol};
    }
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    ${Description0NakedDefaultItemArticle} {
      padding-left: 14px;
      margin-top: 4px;
      margin-bottom: 0;
    }
  }
  @media (max-width: 450px) {
    ${Description0NakedDefaultItemArticle} {
      padding-right: 0.5em;
    }
  }
`

const SmallLandscapeItemArticle = ({ ...props }) => {
  switch (props.theme.mode) {
    case 'mobileS':
      props.truncateTitle.numberOfLines = 3
      break
    case 'mobile':
      props.truncateTitle.numberOfLines = 4
      break
    case 'tablet':
    case 'desktop':
    default:
      props.truncateTitle.numberOfLines = 2
  }
  return <Wrapper {...props} />
}

SmallLandscapeItemArticle.propTypes = {
  ...NakedDefaultItemArticle.propTypes,
}

SmallLandscapeItemArticle.defaultProps = {
  truncateTitle: {
    numberOfLines: 2,
  },
  truncateText: {
    numberOfLines: 3,
  },
  moreLink: false,
}

export default withTheme(SmallLandscapeItemArticle)
